import PlanLeaveAction from "./Action/Routes";
import PlanLeaveReport from "./Reports/Routes";

export default [...PlanLeaveAction, ...PlanLeaveReport];
